export const interpolateString = (template, values) => template?.replace(/%\{([^}]+)\}/g, (match, key) => (values[key] !== undefined ? values[key] : match));
